import { useEffect } from 'react';

import { Outlet } from 'react-router-dom';

import { useNavigationStore } from 'app/store';

/**
 * Wraps the reconciliations list and its run pages. It stays mounted while the admin moves between them, so the type
 * they chose (deductions or salary accruals) is kept, and resets it to deductions once they leave the section.
 */
function ReconciliationsSection() {
  const setReconciliationType = useNavigationStore((state) => state.setReconciliationType);

  useEffect(() => () => setReconciliationType('deductions'), [setReconciliationType]);

  return <Outlet />;
}

export default ReconciliationsSection;
